// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://cfejunmfrwocqhtatxwz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNmZWp1bm1mcndvY3FodGF0eHd6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzYzNzE0MDUsImV4cCI6MjA1MTk0NzQwNX0.5kDzX_q4GyhE3iz4PlS1o4mtVemN-x_5af2SHpwu7S0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);